export const DealerSalesClassEnum = {
  NewAndUsed: 0,
  UsedOnly: 1,
  NewOnly: 2
}



// WEBPACK FOOTER //
// ./scripts/src/shared/enums/dealer.sales.class.enum.js